import { submitInquiry } from './submitInquiry';

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'West Virginia', 'Wisconsin', 'Wyoming'
];

function el(tag, cls, html) {
  const n = document.createElement(tag);
  if (cls) n.className = cls;
  if (html != null) n.innerHTML = html;
  return n;
}

function fieldOptions(f) {
  if (f.options === 'US_STATES') return US_STATES;
  return f.options;
}

function labelHtml(f) {
  return f.label +
    (f.required ? '<span class="req" aria-hidden="true">*</span>'
                : '<span class="optional">optional</span>');
}

function renderRoster(f) {
  const wrap = el('div', 'field full');
  wrap.setAttribute('data-field', '');
  wrap.setAttribute('data-field-id', f.id);
  wrap.appendChild(el('span', 'label-text', labelHtml(f)));
  if (f.help) wrap.appendChild(el('p', 'roster-help', f.help));

  const host = el('div', 'roster');
  for (let i = 1; i <= f.max; i++) {
    const block = el('div', 'roster-item');
    block.setAttribute('data-roster-index', String(i));
    block.appendChild(el('p', 'roster-item__title', (f.itemLabel || 'Item') + ' ' + i));
    const grid = el('div', 'grid');
    f.fields.forEach((sub) => {
      const cell = el('label', 'field' + (sub.full ? ' full' : ''));
      cell.appendChild(el('span', 'label-text', sub.label));
      let input;
      if (sub.type === 'select') {
        input = el('select');
        input.appendChild(new Option(sub.placeholder || 'Select…', ''));
        (fieldOptions(sub) || []).forEach((o) => {
          const v = typeof o === 'string' ? o : o.value;
          const t = typeof o === 'string' ? o : o.label;
          input.appendChild(new Option(t, v));
        });
      } else {
        input = el('input');
        input.type = sub.type || 'text';
        if (sub.placeholder) input.placeholder = sub.placeholder;
      }
      input.name = f.id + '_' + i + '_' + sub.id;
      cell.appendChild(input);
      grid.appendChild(cell);
    });
    block.appendChild(grid);
    if (i > 1) block.hidden = true;
    host.appendChild(block);
  }
  wrap.appendChild(host);
  wrap.appendChild(el('span', 'err', f.errorMessage || "Please complete each child's details."));
  return wrap;
}

function defaultError(f) {
  if (f.type === 'email') return 'Please enter a valid email address.';
  if (f.type === 'select' || f.type === 'radio') return 'Please choose an option.';
  if (f.type === 'checkbox') return 'Please select at least one option.';
  return 'Please complete this field.';
}

function renderField(f) {
  let wrap;
  let input;
  if (f.type === 'roster') return renderRoster(f);
  const needsFieldset = f.type === 'radio' || f.type === 'checkbox';
  const options = fieldOptions(f);

  if (needsFieldset) {
    wrap = el('div', 'field' + (f.full ? ' full' : ''));
    wrap.setAttribute('data-field', '');
    wrap.appendChild(el('span', 'label-text', labelHtml(f)));
    const group = el('div', 'checks');
    if (f.type === 'radio') {
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', f.label);
    }
    (options || []).forEach((opt) => {
      const value = typeof opt === 'string' ? opt : opt.value;
      const text = typeof opt === 'string' ? opt : opt.label;
      const hint = typeof opt === 'string' ? '' : (opt.hint || '');
      const l = el('label', 'check' + (hint ? ' check--hinted' : ''));
      l.innerHTML = '<input type="' + f.type + '" name="' + f.id + '" value="' +
                    String(value).replace(/"/g, '&quot;') + '" /> <span>' + text +
                    (hint ? '<em class="check__hint">' + hint + '</em>' : '') + '</span>';
      group.appendChild(l);
    });
    wrap.appendChild(group);
  } else {
    wrap = el('label', 'field' + (f.full ? ' full' : ''));
    wrap.setAttribute('data-field', '');
    wrap.appendChild(el('span', 'label-text', labelHtml(f)));

    if (f.type === 'select') {
      input = el('select');
      input.appendChild(new Option(f.placeholder || 'Select…', ''));
      (options || []).forEach((opt) => {
        const value = typeof opt === 'string' ? opt : opt.value;
        const text = typeof opt === 'string' ? opt : opt.label;
        input.appendChild(new Option(text, value));
      });
    } else if (f.type === 'textarea') {
      input = el('textarea');
      if (f.placeholder) input.placeholder = f.placeholder;
    } else {
      input = el('input');
      input.type = f.type;
      if (f.placeholder) input.placeholder = f.placeholder;
    }
    input.name = f.id;
    if (f.autocomplete) input.autocomplete = f.autocomplete;
    if (f.required) {
      input.required = true;
      input.setAttribute('aria-required', 'true');
    }
    wrap.appendChild(input);
  }

  wrap.appendChild(el('span', 'err', f.errorMessage || defaultError(f)));
  wrap.setAttribute('data-field-id', f.id);
  if (f.showIf) wrap.hidden = true;
  return wrap;
}

function render(form, schema) {
  schema.sections.forEach((section) => {
    const fs = el('fieldset');
    fs.appendChild(el('legend', null, section.legend));
    if (section.help) fs.appendChild(el('p', 'legend-help', section.help));
    const grid = el('div', 'grid');
    section.fields.forEach((f) => {
      grid.appendChild(renderField(f));
    });
    fs.appendChild(grid);
    form.appendChild(fs);
  });

  const hp = el('div', 'hp');
  hp.setAttribute('aria-hidden', 'true');
  hp.innerHTML = '<label>Do not fill this in <input type="text" name="_hp" tabindex="-1" autocomplete="off" /></label>';
  form.appendChild(hp);
}

function applyRosters(form, schema) {
  schema.sections.forEach((s) => {
    s.fields.forEach((f) => {
      if (f.type !== 'roster') return;
      const host = form.querySelector('[data-field-id="' + f.id + '"]');
      if (!host) return;
      const driver = form.querySelector('[name="' + f.countField + '"]');
      const raw = driver ? driver.value : '';
      let count = parseInt(raw, 10);
      if (!count || isNaN(count)) count = 1;
      count = Math.min(count, f.max);
      host.querySelectorAll('[data-roster-index]').forEach((b) => {
        b.hidden = Number(b.getAttribute('data-roster-index')) > count;
      });
    });
  });
}

function rosterCount(form, f) {
  const host = form.querySelector('[data-field-id="' + f.id + '"]');
  if (!host) return 0;
  return host.querySelectorAll('[data-roster-index]:not([hidden])').length;
}

function applyConditionals(form, schema) {
  schema.sections.forEach((s) => {
    s.fields.forEach((f) => {
      if (!f.showIf) return;
      const host = form.querySelector('[data-field-id="' + f.id + '"]');
      const driver = form.querySelector('[name="' + f.showIf.field + '"]');
      if (!host || !driver) return;
      const current = form.querySelector('[name="' + f.showIf.field + '"]:checked')
                   || form.querySelector('select[name="' + f.showIf.field + '"]');
      const value = current ? current.value : '';
      const show = value === f.showIf.equals;
      host.hidden = !show;
      const inp = host.querySelector('input,select,textarea');
      if (inp) {
        if (f.required) inp.required = show;
        if (!show) {
          inp.value = '';
          host.classList.remove('invalid');
        }
      }
    });
  });
}

function validate(form, schema) {
  let firstBad = null;
  form.querySelectorAll('[data-field]').forEach((f) => { f.classList.remove('invalid'); });

  schema.sections.forEach((s) => {
    s.fields.forEach((f) => {
      if (!f.required) return;
      const host = form.querySelector('[data-field-id="' + f.id + '"]');
      if (!host || host.hidden) return;

      let ok;
      if (f.type === 'roster') {
        ok = true;
        const shown = rosterCount(form, f);
        for (let i = 1; i <= shown; i++) {
          f.fields.forEach((sub) => {
            if (sub.required === false) return;
            const inp = form.querySelector('[name="' + f.id + '_' + i + '_' + sub.id + '"]');
            if (!inp || !inp.value.trim()) ok = false;
          });
        }
      } else if (f.type === 'radio' || f.type === 'checkbox') {
        ok = !!form.querySelector('[name="' + f.id + '"]:checked');
      } else {
        const inp = host.querySelector('input,select,textarea');
        ok = !!(inp && inp.value.trim());
        if (ok && f.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(inp.value.trim());
      }
      if (!ok) {
        host.classList.add('invalid');
        if (!firstBad) firstBad = host;
      }
    });
  });
  return firstBad;
}

function questionSnapshot(form, schema) {
  const out = [];
  schema.sections.forEach((s) => {
    s.fields.forEach((f) => {
      const host = form.querySelector('[data-field-id="' + f.id + '"]');
      if (!host || host.hidden) return;
      const q = { id: f.id, label: f.label, type: f.type, required: !!f.required };
      const options = fieldOptions(f);
      if (options) {
        q.options = options.map((o) => (typeof o === 'string' ? o : o.label));
      }
      if (f.type === 'roster') {
        q.perItem = f.fields.map((sub) => ({ id: sub.id, label: sub.label, type: sub.type || 'text' }));
        q.itemsShown = rosterCount(form, f);
      }
      out.push(q);
    });
  });
  return out;
}

function answers(form, schema) {
  const data = new FormData(form);
  const out = {};
  schema.sections.forEach((s) => {
    s.fields.forEach((f) => {
      const host = form.querySelector('[data-field-id="' + f.id + '"]');
      if (!host || host.hidden) return;
      if (f.type === 'roster') {
        const list = [];
        const shown = rosterCount(form, f);
        for (let i = 1; i <= shown; i++) {
          const item = {};
          f.fields.forEach((sub) => {
            const v = (data.get(f.id + '_' + i + '_' + sub.id) || '').toString().trim();
            if (v) item[sub.id] = v;
          });
          if (Object.keys(item).length) list.push(item);
        }
        if (list.length) out[f.id] = list;
      } else if (f.type === 'checkbox') {
        const vals = data.getAll(f.id).map(String);
        if (vals.length) out[f.id] = vals;
      } else {
        const v = (data.get(f.id) || '').toString().trim();
        if (v) out[f.id] = v;
      }
    });
  });
  return out;
}

export function prefillEmpty(form, values) {
  if (!form || !values) return;
  Object.keys(values).forEach((name) => {
    const value = values[name];
    if (value == null || value === '') return;
    const inp = form.querySelector(`[name="${name}"]`);
    if (inp && !inp.value) inp.value = value;
  });
}

export function mountInquiryForm({
  schema,
  form,
  submitBtn,
  confirmEl,
  confirmNameEl,
  confirmRefEl,
  errorEl,
  formHeadEl,
  formFootEl,
}) {
  form.innerHTML = '';
  render(form, schema);
  applyConditionals(form, schema);
  applyRosters(form, schema);

  const onChange = (e) => {
    if (e.target.type === 'checkbox' || e.target.type === 'radio') {
      form.querySelectorAll('[name="' + e.target.name + '"]').forEach((i) => {
        const box = i.closest('.check');
        if (box) box.classList.toggle('selected', i.checked);
      });
    }
    applyConditionals(form, schema);
    applyRosters(form, schema);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    errorEl.classList.remove('show');
    if (form.querySelector('[name="_hp"]').value) return;

    const bad = validate(form, schema);
    if (bad) {
      errorEl.textContent = 'Please check the highlighted fields below.';
      errorEl.classList.add('show');
      bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const inp = bad.querySelector('input,select,textarea');
      if (inp) inp.focus({ preventScroll: true });
      return;
    }

    const a = answers(form, schema);
    const honeypot = form.querySelector('[name="_hp"]');
    const payload = {
      source: schema.source,
      questions: questionSnapshot(form, schema),
      answers: a,
      school_name: schema.schoolName(a),
      contact_name: a[schema.map.contactName] || '',
      email: a[schema.map.email] || '',
      phone: a[schema.map.phone] || '',
      message: a[schema.map.message] || '',
      _hp: honeypot ? honeypot.value : ''
    };

    submitBtn.disabled = true;
    const originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Sending…';

    try {
      const res = await submitInquiry(payload);
      if (formHeadEl) formHeadEl.hidden = true;
      form.hidden = true;
      if (formFootEl) formFootEl.hidden = true;
      const first = (payload.contact_name || '').split(' ')[0];
      confirmNameEl.textContent = (first ? first + ', our' : 'Our') + ' ' + schema.confirmTail;
      if (res && res.reference) {
        confirmRefEl.textContent = 'Reference ' + res.reference;
      }
      confirmEl.classList.add('show');
      confirmEl.focus();
      confirmEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      console.error('[acuity] submit failed:', err);
      errorEl.textContent = 'Something went wrong sending your details. Please try again in a moment.';
      errorEl.classList.add('show');
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
    }
  };

  form.addEventListener('change', onChange);
  form.addEventListener('submit', onSubmit);

  return () => {
    form.removeEventListener('change', onChange);
    form.removeEventListener('submit', onSubmit);
    form.innerHTML = '';
    form.hidden = false;
  };
}
